// src/components/store/sections/faqs/FaqV101OrigamifaqIndigoPulse.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV101OrigamifaqIndigoPulse(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={101}
      archKey="origami_faq"
      archLabel="Origami Ribbon Panels"
      palName="IndigoPulse"
      grad="from-indigo-500 via-blue-600 to-violet-700"
      lightBg="bg-indigo-50"
      textCol="text-indigo-700"
      borderCol="border-indigo-200"
      btnCls="bg-indigo-600 hover:bg-indigo-700"
      hexCol="#6366f1"
      {...props}
    />
  );
}
